module.exports = __webpack_public_path__ + "img/burger_menu.09d28a5b.svg";